import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext } from 'react';

interface ActionContextState {
  location: 'board' | 'card' | 'member';
}

export const ActionContext = createContext<ActionContextState>({
  location: 'card',
});

interface ActionContextProviderProps {
  location: 'board' | 'card' | 'member';
}

export const ActionContextProvider: FunctionComponent<
  PropsWithChildren<ActionContextProviderProps>
> = ({ location, children }) => {
  return (
    // eslint-disable-next-line @eslint-react/no-unstable-context-value -- FIXME
    <ActionContext.Provider value={{ location }}>
      {children}
    </ActionContext.Provider>
  );
};
